const footerMenuList = [
  {
    id: 1,
    title: "Marketplace",
    diffClass: "md:col-start-7",
    list: [
      {
        id: 1,
        href: "/",
        text: "Home",
      },
      {
        id: 2,
        href: "/listing",
        text: "Recently Listed",
      },
      {
        id: 3,
        href: "/import",
        text: "Import / Create",
      },
    ],
  },
];

const socialIcons = [
  {
    id: 1,
    href: "https://www.facebook.com/REIChain",
    text: "facebook",
  },
  {
    id: 2,
    href: "https://www.twitter.com/_rei_chain",
    text: "twitter",
  },
  {
    id: 3,
    href: "https://discord.gg/jCsZnjtT9Q",
    text: "discord",
  },
  {
    id: 4,
    href: "https://t.me/reichain",
    text: "telegram-th",
  },
  {
    id: 5,
    href: "https://t.me/reichainglobal",
    text: "telegram-en",
  },
];

export { footerMenuList, socialIcons };
